export function SeasonalTreeIcon() {
  return (
    <svg
      className="size-[46px]"
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="ic_treexxhdpi">
        <path
          id="Vector"
          d="M28.6851 41.0046C26.8733 41.0046 25.3097 39.9068 24.6383 38.3515C23.9577 39.9068 22.4033 41.0046 20.5914 41.0046H19.3406C17.0136 41.0046 15.1098 39.2115 14.9442 36.9426H9.88563C7.8622 36.9426 6.04111 35.8356 5.11217 34.0425C4.19243 32.2585 4.33959 30.1269 5.51686 28.4984L7.55868 25.6623C7.52189 25.5342 7.4851 25.4153 7.45751 25.2872C7.1264 23.8417 7.42992 22.3047 8.28528 21.0697L10.8698 17.3736C10.5294 15.9739 10.7594 14.446 11.6147 13.1744L15.5144 7.37413C16.517 5.89204 18.1817 5.00462 19.9752 5.00462C21.7687 5.00462 23.4426 5.89204 24.4359 7.37413L28.3264 13.1744C28.3816 13.2659 28.4368 13.3482 28.492 13.4397C28.7679 13.3939 29.0438 13.3757 29.3198 13.3757C31.0857 13.3757 32.7228 14.2448 33.7069 15.7086L37.4043 21.2161C38.2321 22.442 38.4712 23.9149 38.1677 25.2689L40.5682 28.7088C41.6903 30.3098 41.8283 32.3866 40.9085 34.1248C39.998 35.8631 38.2045 36.9426 36.2362 36.9426H34.3508C34.1852 39.2115 32.2721 41.0046 29.9544 41.0046H28.7035H28.6851Z"
          fill="url(#paint0_linear_seasonal_tree)"
        />
        <g id="Group">
          <path
            id="Vector_2"
            d="M20.6068 37.911H19.4032C18.9077 37.911 18.5006 37.4487 18.5006 36.8859V32.0015C18.5006 31.9512 18.536 31.911 18.5802 31.911H21.4209C21.4652 31.911 21.5006 31.9512 21.5006 32.0015V36.8859C21.5006 37.4487 21.0935 37.911 20.5979 37.911H20.6068Z"
            fill="#084F1B"
          />
          <path
            id="Vector_3"
            d="M7.87497 30.9155L11.2961 25.9731C10.3832 25.4408 9.99591 24.1577 10.6691 23.1597L14.4683 17.5234C13.7306 16.9341 13.4448 15.8126 14.0349 14.9001L17.9356 8.87419C18.6826 7.71463 20.3424 7.71463 21.0894 8.87419L24.9901 14.9001C25.5802 15.8126 25.3036 16.9341 24.5659 17.5234L28.3651 23.1597C29.0383 24.1577 28.651 25.4408 27.7381 25.9731L31.1592 30.9155C32.0537 32.2081 31.1592 34.0045 29.6193 34.0045H9.41496C7.87497 34.0045 6.97126 32.2081 7.87497 30.9155Z"
            fill="url(#paint1_linear_seasonal_tree)"
          />
          <g id="Group_2">
            <path
              id="Vector_4"
              d="M30.1067 37.9111H28.9032C28.4076 37.9111 28.0005 37.4488 28.0005 36.886V32.0016C28.0005 31.9513 28.0359 31.9111 28.0802 31.9111H30.9209C30.9652 31.9111 31.0005 31.9513 31.0005 32.0016V36.886C31.0005 37.4488 30.5935 37.9111 30.0979 37.9111H30.1067Z"
              fill="#084F1B"
            />
            <path
              id="Vector_5"
              d="M36.2397 33.9111H22.7612C21.3434 33.9111 20.5088 32.2494 21.3164 31.0451L24.8252 25.7986C24.1342 25.2478 23.8829 24.1928 24.4393 23.3433L28.0467 17.7233C28.7377 16.6404 30.2722 16.6404 30.9632 17.7233L34.5706 23.3433C35.118 24.1928 34.8667 25.2478 34.1847 25.7986L37.6845 31.0451C38.4921 32.2494 37.6576 33.9111 36.2487 33.9111H36.2397Z"
              fill="url(#paint2_linear_seasonal_tree)"
            />
          </g>
        </g>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_seasonal_tree"
          x1="23.001"
          y1="39.8794"
          x2="23.001"
          y2="6.48682"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00E300" />
          <stop offset="0.509615" stopColor="#00E300" stopOpacity="0.945" />
          <stop offset="0.600962" stopColor="#17FC00" stopOpacity="0.89" />
          <stop offset="1" stopColor="#8CFC00" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_seasonal_tree"
          x1="19.5217"
          y1="33.5297"
          x2="19.5217"
          y2="5.01575"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#007900" />
          <stop offset="1" stopColor="#00C800" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_seasonal_tree"
          x1="29.4915"
          y1="35.5449"
          x2="29.4915"
          y2="11.1604"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#045111" />
          <stop offset="1" stopColor="#019B0C" />
        </linearGradient>
      </defs>
    </svg>
  )
}
